import {
  LIST_PLURALL_CREDENTIAL_REQUEST,
  LIST_PLURALL_CREDENTIAL_SUCCESS,
  LIST_PLURALL_CREDENTIAL_ERROR,
  GET_PLURALL_CREDENTIAL_REQUEST,
  GET_PLURALL_CREDENTIAL_SUCCESS,
  GET_PLURALL_CREDENTIAL_ERROR,
  ADD_PLURALL_CREDENTIAL_REQUEST,
  ADD_PLURALL_CREDENTIAL_SUCCESS,
  ADD_PLURALL_CREDENTIAL_ERROR,
  EDIT_PLURALL_CREDENTIAL_REQUEST,
  EDIT_PLURALL_CREDENTIAL_SUCCESS,
  EDIT_PLURALL_CREDENTIAL_ERROR,
} from '../actions';

export const listPlurallCredentialRequest = ({ schoolId, search, searchBy }) => ({
  type: LIST_PLURALL_CREDENTIAL_REQUEST,
  payload: { schoolId, search, searchBy },
});
export const listPlurallCredentialSuccess = (credentials) => ({
  type: LIST_PLURALL_CREDENTIAL_SUCCESS,
  payload: credentials,
});
export const listPlurallCredentialError = (message) => ({
  type: LIST_PLURALL_CREDENTIAL_ERROR,
  payload: { message },
});

export const getPlurallCredentialRequest = (id) => ({
  type: GET_PLURALL_CREDENTIAL_REQUEST,
  payload: { id },
});
export const getPlurallCredentialSuccess = (credential) => ({
  type: GET_PLURALL_CREDENTIAL_SUCCESS,
  payload: credential,
});
export const getPlurallCredentialError = (message) => ({
  type: GET_PLURALL_CREDENTIAL_ERROR,
  payload: { message },
});

export const addPlurallCredentialRequest = (credential) => ({
  type: ADD_PLURALL_CREDENTIAL_REQUEST,
  payload: { credential },
});
export const addPlurallCredentialSuccess = (credential) => ({
  type: ADD_PLURALL_CREDENTIAL_SUCCESS,
  payload: credential,
});
export const addPlurallCredentialError = (message) => ({
  type: ADD_PLURALL_CREDENTIAL_ERROR,
  payload: { message },
});

export const editPlurallCredentialRequest = (credential) => ({
  type: EDIT_PLURALL_CREDENTIAL_REQUEST,
  payload: { credential },
});
export const editPlurallCredentialSuccess = (credential) => ({
  type: EDIT_PLURALL_CREDENTIAL_SUCCESS,
  payload: credential,
});
export const editPlurallCredentialError = (message) => ({
  type: EDIT_PLURALL_CREDENTIAL_ERROR,
  payload: { message },
});
